import ButtonBack from "components/buttonBack/buttonBack";

import { Breakfast } from "./types";

import DetailHero from "./components/detailHero/detailHero";
import EventInfo from "./components/eventInfo/eventInfo";
import useBreakfastsRsvp from "./hooks";
import PromoBlock from "./components/promoBlock/promoBlock";

type BreakfastDetailViewProps = Breakfast;

const BreakfastDetailView = (props: BreakfastDetailViewProps) => {
  const isPrevious = new Date(props.dateTime).getTime() < new Date().getTime();
  const { isReady: isRsvpReady, hasRsvped } = useBreakfastsRsvp();

  return (
    <main className={"bg-[#F4F4F6] py-[100px] lg:py-[108px]"}>
      <div
        className={
          "container m-auto w-full max-w-full px-5 lg:max-w-[1280px] lg:px-[30px]"
        }
      >
        <section className={"mb-[10px]"}>
          <ButtonBack component={"link"} href={"/breakfast"}>
            Back to the list
          </ButtonBack>
        </section>
        <section className={"mb-[30px] text-black-rock lg:mb-10"}>
          <DetailHero
            {...props}
            isPrevious={isPrevious}
            isRsvpReady={isRsvpReady}
            hasRsvped={hasRsvped}
          />
        </section>
        <section className={"text-black-rock"}>
          <EventInfo {...props} isPrevious={isPrevious} />
        </section>
        {isPrevious && (
          <section className={"mt-[70px] flex justify-center"}>
            <PromoBlock
              bottomPromoBlockHeading={props.bottomPromoBlockHeading}
              bottomPromoBlockCtaUrl={props.bottomPromoBlockCtaUrl}
              bottomPromoBlockCtaLabel={props.bottomPromoBlockCtaLabel}
            />
          </section>
        )}
      </div>
    </main>
  );
};

export default BreakfastDetailView;
